/**
 * White Label Branding Configuration
 * 
 * This file centralizes all branding elements to support white labeling.
 * Modify this file to rebrand the application.
 */

const brandingConfig = {
  // Basic Information
  appName: "Minicar Kassel",
  companyName: "Minicar Kassel",
  slogan: "Die günstige Alternative zum Taxi", // White-Label: Slogan anpassen (erscheint z.B. im Login-Bereich)

  // Contact Information
  email: "post@minicar-online.de",
  phone: "+49 561 811081",
  address: "Angersbachstr. 2a, 34127 Kassel",
  owner: "Hüseyin Çakır", // White-Label: Inhaber/Geschäftsführer anpassen (Pflicht für Impressum gemäß TMG § 5)
  website: "https://minicar-kassel.de", // White-Label: Website-URL anpassen

  // Supervisory Authority (Aufsichtsbehörde für Personenbeförderung)
  // White-Label: An die örtliche Aufsichtsbehörde des Kunden anpassen!
  supervisoryAuthority: {
    name: "Stadt Kassel — Ordnungsamt",
    department: "Ordnungs- und Aufsichtsangelegenheiten, Erlaubnispflichtige Gewerbe",
    address: "Rathaus, Obere Königsstraße 8, 34117 Kassel",
  },

  // Data Protection Authority (Datenschutz-Aufsichtsbehörde)
  // White-Label: An das Bundesland des Kunden anpassen! (siehe BRANDING_VERBESSERUNGEN.md Abschnitt 6.4)
  dataProtectionAuthority: {
    name: "Der Hessische Beauftragte für Datenschutz und Informationsfreiheit",
    address: "Postfach 31 63, 65021 Wiesbaden",
    phone: "0611 1408-0",
    website: "https://datenschutz.hessen.de",
  },

  // Legal Information
  copyright: `© ${new Date().getFullYear()} Minicar Kassel`,
  
  // Colors
  colors: {
    primary: "#C10C1A", // Markenrot aus dem Kunden-CI
    secondary: "#212121", // Dark Gray
    accent: "#000000", // Schrift auf hellem Grund
    success: "#4CAF50", // Green
    error: "#F44336", // Red
    warning: "#FF9800", // Orange
    info: "#2196F3", // Blue
    background: "#FFFFFF", // White
    text: {
      primary: "#333333", // Near Black
      secondary: "#757575", // Medium Gray
      light: "#FFFFFF", // White
    }
  },
  
  // Logos and Images
  logos: {
    // White-Label-Anpassung: Dieser Mandant führt nur EIN Logo (Bildmarke und
    // Schriftzug sind eine zusammenhängende Marke). Deshalb zeigen alle
    // Schlüssel auf dieselbe Datei — und in den Layouts wird kein separates
    // Icon davorgestellt, sonst erschiene die Bildmarke doppelt.
    // Vorbild: Taxi Pinneberg.
    primary: "/assets/MinicarKassel_Logo.png",
    primaryOnDark: "/assets/MinicarKassel_Logo.png",
    icon: "/assets/MinicarKassel_Logo.png",
    iconOnDark: "/assets/MinicarKassel_Logo.png",
    favicon: "/favicon.ico",
    mobileLogo: "/assets/MinicarKassel_Logo.png",
  },
  
  // UI Elements
  ui: {
    borderRadius: "4px",
    // 'rounded', 'square', 'pill' — steuert die Eckenrundung aller Buttons
    // (theme.js). NextCab nutzt "pill"; die Landing Page setzt keine eigenen
    // Radien mehr, damit White-Label-Mandanten hier wirklich durchgreifen.
    buttonStyle: "pill",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
  
  // Features Config
  features: {
    enableReports: true,
    enableLiveMap: true,
    enableShiftPlanning: true,
  },
  
  // Social Media
  socialMedia: {
    facebook: "https://facebook.com/nextcab",
    twitter: "https://twitter.com/nextcab",
    instagram: "https://instagram.com/nextcab",
  },
};

export default brandingConfig;